import React from "react";
import { useEffect, useState } from "react";
import { REACT_APP_LIFERAY_HOST } from "./services/liferay";
import "./assets/app.css";
import LoadingCircle from "./assets/loading-circle.gif";
import FavoriteIcon from "./assets/icon-favorite.png";
import NotFavoriteIcon from "./assets/not-icon-favorite.png";
import ArrowRight from "./assets/arrow-right.png";
import {
  fetchApps,
  fetchAppsCategories,
  fetchUserAccount,
  fetchUserApps,
  postUserAppFavoris,
  putUserAppFavoris,
} from "./services/api";
import Loader from "./components/Loader";
import Error from "./components/Error";
import { useMe, useMeRoles } from "./hooks/user-hook";
import { flatMap, map } from "lodash";
import { hasAccessPTBA, hasAccessReseau, hasAccessStock, hasAccessVente } from "./helpers/role-helper";

{/*search input*/}
function SearchInput({ searchTerm, onSearchChange }) {
  const handleChange = (event) => {
    onSearchChange(event.target.value);
  };

  return (
    <input
      type="text"
      className="search-input"
      placeholder="Rechercher"
      value={searchTerm}
      onChange={handleChange}
    />
  );
}

const APP_CODE = ["STOCK", "VENTE", "RESEAU", "PTBA"];
function App() {
  const [tabApps, setTabApps] = useState([]);
  const [tabSelectedBtnTag, setTabSelectedBtnTag] = useState("all");
  const [appFullList, setAppFullList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [updatingAppId, setUpdatingAppId] = useState(null);
  const [categrorieEntries, setCategrorieEntries] = useState([]);
  const [dataLoading, setDataLoading] = useState(true);
  const [error, setError] = useState(false);

  const {data: me, isLoading: isLoadingMe} = useMe()
  const {data: meRoles, isLoading: isLoadingMeRoles} = useMeRoles(me?.emailAddress)

  const meModules = map(meRoles?.organizationBriefs || [], "name") || [];
  //const meRoleIds = flatMap((meRoles?.organizationBriefs || []), org => map(org?.roleBriefs || [], "id")) || []

  console.log("meModules ::: ", meModules);

  // Fonction pour filtrer les apps selon la recherche
  const filterAppsBySearch = (apps, searchTerm) => {
    if (!searchTerm.trim()) return apps;
    
    return apps.filter(app => 
      app.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
      app.description.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  // Fonction pour obtenir les apps filtrées par catégorie ET par recherche
  const getFilteredApps = () => {
    let matchApps;
    const appFavorites = appFullList.filter((item) => item.userApp.estFavori);
    
    switch (tabSelectedBtnTag) {
      case "all":
        matchApps = appFullList.filter((item) =>
        item.categorie.key !=="backoffice");  
        break;
      case "favorite": 
        matchApps = appFavorites; 
        break; 
      default:
        matchApps = appFullList.filter((item) =>
        item.categorie.key.includes(tabSelectedBtnTag)
        );
        break;
    }
    
    // Appliquer le filtre de recherche
    return filterAppsBySearch(matchApps, searchTerm);
  };

  //When change tab, filter and load apps link to that tab (tag)
  const toggleTab = (categoryKey) => {
    setTabSelectedBtnTag(categoryKey);
  };

  // Gestionnaire pour le changement de terme de recherche
  const handleSearchChange = (newSearchTerm) => {
    setSearchTerm(newSearchTerm);
  };

  // Effet pour mettre à jour tabApps quand la catégorie ou la recherche change
  useEffect(() => {
    const filteredApps = getFilteredApps();
    setTabApps(filteredApps);
  }, [tabSelectedBtnTag, searchTerm, appFullList]);

  //toogle add/remove app as favorite
  const toggleFavorite = async (app) => {
    try {
      setUpdatingAppId(app.id);
      const userAppPayload = {
        ...app.userApp,
        estFavori: !app.userApp.estFavori,
      };
      if (userAppPayload.id) {
        // cette application a deja été ajouté ou retiré comme favoris
        await putUserAppFavoris(app.userApp.id, userAppPayload);
      } else {
        const returnData = await postUserAppFavoris(userAppPayload);
        userAppPayload.id = returnData.id;
      }
      const appsClone = [...appFullList];
      const appsIndex = appFullList.findIndex((item) => item.id === app.id);
      appsClone[appsIndex] = { ...app, userApp: userAppPayload };

      setAppFullList(appsClone);
      setUpdatingAppId(null);
    } catch (error) {
      console.log("🚀 ~ toggleFavorite ~ error:", error);
    }
  };

  const fetchData = async () => {
    try {
      const userData = await fetchUserAccount();
      const categories = await fetchAppsCategories();
      const apps = await fetchApps();
      const userApps = await fetchUserApps(userData.id);
      //associer chaque app a userApp si exist
      console.log("apps ::: ", apps);
    const appItems = [...apps.items]
  .filter(aItem => 
    aItem.isActive === true
  )
  .map((aItem) => {
    const userApp = userApps.items.find(
      (item) => item.r_app_c_appId === aItem.id
    );
    aItem.userApp = {
      id: userApp?.id || null,
      estFavori: userApp?.estFavori || false,
      r_userAppFavoris_userId: userData.id,
      r_app_c_appId: aItem.id,
    };
    return aItem;
  });
      setCategrorieEntries(categories.listTypeEntries);
      setAppFullList(appItems);
      // setFavoritesApps(appItems.filter(item=>item.userApp.estFavori));
      setDataLoading(false);
    } catch (error) {
      setError(true);
      setDataLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (dataLoading) return <Loader />;
  if (error) return <Error />;
  
  const appFavorites = appFullList.filter((item) => item.userApp.estFavori);
  
  console.log("tabApps : ::: ", tabApps);
  return (
    <div className="container-fluid" id="cx-react-apps">

{/*ajout debut*/}
<div className="big-container">
		 <h1>Toutes les applications par catégories</h1>

    <div className="header-container">

        <div className="search-container">
            <div className="search-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                </svg>
            </div>
            <SearchInput 
              searchTerm={searchTerm} 
              onSearchChange={handleSearchChange}
            />
        </div>
        
        <div className="tabs">
            <button className={`${tabSelectedBtnTag === "all" ? "tab active first-tab" : "tab"}`}onClick={() => toggleTab("all")}>Toutes</button>
            <button className={`${tabSelectedBtnTag === "favorite" ? "tab active" : "tab"}`}onClick={() => toggleTab("favorite")}>Favoris</button>

            {categrorieEntries.filter(category => category.key !== "backoffice" && category.key !=="label").map((category)=>(
                <button 
                  key={category.key}
                  className={`tab ${tabSelectedBtnTag === category.key? "tab active": "tab"}`} 
                  onClick={() => toggleTab(category.key)}
                >
                    {category.name}
                </button>))}
            
        </div>
    </div>  

    <h2>{tabSelectedBtnTag === "all"
    ? "Toutes les applications"
    : tabSelectedBtnTag === "favorite"
    ? "Applications favorites"
    : categrorieEntries.find((c) => c.key === tabSelectedBtnTag)?.name || ""}</h2>
    
    {searchTerm && (
      <p style={{ fontStyle: 'italic', color: '#666', marginBottom: '1rem' }}>
        Résultats pour "{searchTerm}" : {tabApps.length} application(s) trouvée(s)
      </p>
    )}
    
     <div className="app-grid">

        {tabApps.map((app)=>(
          <div className={`app-card  ${
            app?.id === 91694 && !hasAccessPTBA(meModules) ? "disabled-card" :
            app?.id === 59924 && !hasAccessStock(meModules) ? "disabled-card" :
            app?.id === 59767 && !hasAccessVente(meModules) ? "disabled-card" :
            app?.id === 59809 && !hasAccessReseau(meModules) ? "disabled-card" :
            ""
            }`} key={app.id}>
              <span
                    onClick={() => (!updatingAppId ? toggleFavorite(app) : null)}
                  >
                      {updatingAppId === app.id ? (
                      <img
                        src={LoadingCircle}
                        style={{ width: "24px" }}
                        alt="loading-circle"
                      />
                    ) :  (app.categorie.key!=="label" && app.userApp.estFavori) ? (
                      <i className="fas fa-star favorite-icon" style={{color: "#f4b400"}}></i>
                    ) : (app.categorie.key!=="label" && !app.userApp.estFavori) ? (
                      <i className="fas fa-star favorite-icon" style={{color: "#979ea04f"}}></i>
                ): (<i></i>)}

                    </span>
              <a style={{textDecoration: "none"}}
                href={app.external ? `${app.url}`:`${REACT_APP_LIFERAY_HOST}/${app.url}`} target= {app.external?'_blank':''}
                >

                <div className="app-icon">
                    <img src={app.icon?.link?.href && `${REACT_APP_LIFERAY_HOST}${app.icon.link.href}`} alt={app.icon?.link?.label && `${app.icon.link.label}`} class="icon-img"/>
                </div>
                <div className="app-name">{app.nom}</div>
                <div className="app-description">{app.description}</div>
            </a>
          </div>
        ))}
        
        {tabApps.length === 0 && searchTerm && (
          <div style={{ 
            gridColumn: '1 / -1', 
            textAlign: 'center', 
            padding: '2rem',
            color: '#666'
          }}>
            Aucune application trouvée pour "{searchTerm}"
          </div>
        )}
    
       
        
    </div>
	</div>
{/*fin ajout*/}

    </div>
  );
}

export default App;